import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b075d0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "btn btn--left"
}
const _hoisted_2 = { class: "btn__txt" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn__circle" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn__svg-circle" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "100%",
    height: "100%"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "50%",
      cy: "50%",
      r: "46%"
    })
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn__line" }, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "btn btn--right"
}
const _hoisted_7 = { class: "btn__txt" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn__circle" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn__svg-circle" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "100%",
    height: "100%"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "50%",
      cy: "50%",
      r: "46%"
    })
  ])
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn__line" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.layout.includes('left'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_router_link, { to: _ctx.url }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.text), 1),
              _hoisted_3,
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.layout.includes('right'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_router_link, { to: _ctx.url }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.text), 1),
              _hoisted_8,
              _hoisted_9,
              _hoisted_10
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}